module.exports = __webpack_public_path__ + "static/media/grow.3c21fd53.png";